/**
 * @generated SignedSource<<d1b651d3cb4471937278d9c6edfc8cb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceType = "GROUP" | "SOLO";
export type CreateServiceInput = {
  description?: string | null;
  name: string;
  placeholder?: string | null;
  type?: ServiceType | null;
};
export type AddServiceDialogMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  input: CreateServiceInput;
};
export type AddServiceDialogMutation$data = {
  readonly addServiceToServiceGroup: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"ServiceRow_service">;
    };
  };
};
export type AddServiceDialogMutation = {
  response: AddServiceDialogMutation$data;
  variables: AddServiceDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddServiceDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ServiceNode",
        "kind": "LinkedField",
        "name": "addServiceToServiceGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Service",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ServiceRow_service"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddServiceDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ServiceNode",
        "kind": "LinkedField",
        "name": "addServiceToServiceGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Service",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ServiceEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "15f5e6fd613ae2b7f9a3d2fbe584992e",
    "id": null,
    "metadata": {},
    "name": "AddServiceDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AddServiceDialogMutation(\n  $id: ID!\n  $input: CreateServiceInput!\n) {\n  addServiceToServiceGroup(id: $id, input: $input) {\n    node {\n      ...ServiceRow_service\n      id\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment ServiceRow_service on Service {\n  id\n  name\n  type\n  price\n  ...SortableEntityTableRow_entity\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "548f00e92d01c46b7e4a28e21e3a53b5";

export default node;
